<template>
  <div class="collection-card-small">
    <div class="collection-card-small__preview">
      <img :src="image" alt="" class="collection-card-small__image" />
      <div class="collection-card-small__title ta-center">
        {{ title }}
      </div>
    </div>
    <div class="collection-card-small__musics">
      <SliderButtons
        :options="swiperOption"
        :owner="$parent.$parent"
        class-button-next="collection-card-small__button-next"
        class-button-prev="collection-card-small__button-prev"
        class-buttons="collection-card-small__button"
      >
        <swiper-slide v-for="({title}, idx) in collection" :key="'track' + idx">
          <div
            :class="[
              'collection-card-small__audio',
              isPlayed[idx] ? 'collection-card-small__audio-play' : 'collection-card-small__audio-pause',
            ]"
            onclick="
              const currentCard = this.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.__vue__;
              currentCard.playPause(+this.parentElement.getAttribute('data-swiper-slide-index'));
            "
          >
            <p>{{ title }}</p>
          </div>
        </swiper-slide>
      </SliderButtons>
    </div>
  </div>
</template>
<script>
import {SwiperSlide} from 'vue-awesome-swiper';
import SliderButtons from './SliderButtons.vue';

export default {
  name: 'CollectionCardSmall',
  components: {
    SwiperSlide,
    SliderButtons,
  },
  props: {
    isPlayed: Array,
    image: String,
    collection: {
      type: Array,
      default: () => [],
    },
    title: String,
  },
  data() {
    return {
      swiperOption: {
        init: true,
        slidesPerView: 1,
        initialSlide: 0,
        centeredSlides: true,
        loop: true,
      },
    };
  },
  methods: {
    playPause(idx) {
      this.$emit(
        'update:isPlayed',
        this.isPlayed.map((item, idxItem) => (idxItem === idx ? !item : item))
      );
      this.$emit('playPause', !this.isPlayed[idx], idx);
    },
  },
};
</script>

<style>
.collection-card-small__button {
  width: 40px;
  height: 70px;
  cursor: pointer;
  background-color: transparent;
}
.collection-card-small__button-prev {
  background-image: url(~IMAGES/icons/prev_m_blue.svg);
}
.collection-card-small__button-next {
  background-image: url(~IMAGES/icons/next_m_blue.svg);
}
</style>
<style scoped>
.collection-card-small {
  cursor: pointer;
  border-radius: 10px;
  padding: 0 8px;
  box-sizing: border-box;
  margin-bottom: 10px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 1.30664px 3.91991px rgba(0, 0, 0, 0.08);
  margin-right: 0;
  background-color: var(--button-text-color);
}
.collection-card-small__preview {
  position: relative;
}
.collection-card-small__preview::after {
  content: '';
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 70px;
  background-image: url(~IMAGES/elements/waves_in_slider.png);
  background-position: center bottom;
  background-size: 100% auto;
}
.collection-card-small__image {
  display: block;
  width: 100%;
  border-radius: 10px 10px 0 0;
  box-shadow: 0px 1.30664px 3.91991px rgba(0, 0, 0, 0.08);
}
.collection-card-small__title {
  color: var(--button-text-color);
  position: absolute;
  z-index: 2;
  bottom: 12px;
  text-transform: none;
  left: 15px;
  font-size: 14px;
}
.collection-card-small__musics {
  width: 100%;
  display: block;
  overflow: hidden;
  border: 1px solid #dcdcdc;
  border-top: none;
  padding: 0 10px;
  border-radius: 0 0 8px 8px;
  text-align: center;
  text-transform: none;
  font-size: 13px;
  color: #000;
  box-sizing: border-box;
}
.collection-card-small__audio {
  height: 60px;
  border: 1px solid #3c6af9;
  border-radius: 5px;
  background-position: center 9px;
}
.collection-card-small__audio p {
  padding: 37px 5px 0 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.collection-card-small__audio-play {
  background-image: url(~IMAGES/icons/pause_blue.svg);
}
.collection-card-small__audio-pause {
  background-image: url(~IMAGES/icons/play_blue.svg);
}
</style>
